import http from '@/utils/http'

export function getPractisesDetail(id){
    return  http(`/practises/${id}`)
}

export function putPractisesAnswer(id, data){
    return  http.post(`/practises/${id}/answer_result`, data)
}

export function getPractisesDetailByAnswer(params){
    return  http(`/practisesByAnswer`,{params})
}